module.exports = __webpack_public_path__ + "staticcomp/img/cover.ce9a840.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/5/cover.jpg
// module id = BD5z
// module chunks = 39